import { useRef, useEffect } from "react";
import { getPastEvents } from "./utils";
import eventsData from "./eventsData";
import "./InfiniteMovingCards.css";

function DernierEvent() {
  const pastEvents = getPastEvents(eventsData);
  const scrollRef = useRef(null);
  const isPaused = useRef(false);
  const pos = useRef(0);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let animId;
    const step = () => {
      if (!isPaused.current && container) {
        pos.current += 0.7;
        const half = container.scrollWidth / 2;
        if (pos.current >= half) {
          pos.current -= half;
        }
        container.scrollLeft = Math.round(pos.current);
      }
      animId = requestAnimationFrame(step);
    };
    animId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animId);
  }, []);

  const handleManualScroll = (amount) => {
    const container = scrollRef.current;
    if (!container) return;
    isPaused.current = true;
    container.scrollBy({ left: amount, behavior: "smooth" });
    setTimeout(() => {
      pos.current = container.scrollLeft;
      isPaused.current = false;
    }, 700);
  };

  return (
    <section className="relative py-4">
      <div className="petal absolute inset-0">
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/82d0cc958661239053bacf859eb20cb7705bd8eaaa3a7ec83096b7f29ce6c224?apiKey=aa921c22d5e8470a9701bc1a79b29d5d&" alt="" className="absolute shrink-0 bottom-2 ml-14 aspect-[0.56] fill-teal-300 fill-opacity-20 w-[40px] max-md:mt-10" />
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/077526e80df6595ab71c00788b3a9e12ea1dfdd7ed1017c00c1c9e91f217aab0?apiKey=aa921c22d5e8470a9701bc1a79b29d5d&" alt="" className="absolute top-2/3 left-1/2 rotate-45 w-9 aspect-[0.67] fill-yellow-600 fill-opacity-20" />
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/82d0cc958661239053bacf859eb20cb7705bd8eaaa3a7ec83096b7f29ce6c224?apiKey=aa921c22d5e8470a9701bc1a79b29d5d&" alt="" className="absolute shrink-0 top-14 left-0 ml-64 rotate-45 aspect-[0.56] fill-teal-300 fill-opacity-20 w-[40px] max-md:mt-10" />
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/077526e80df6595ab71c00788b3a9e12ea1dfdd7ed1017c00c1c9e91f217aab0?apiKey=aa921c22d5e8470a9701bc1a79b29d5d&" alt="" className="absolute top-52 right-16 rotate-45 w-9 aspect-[0.67] fill-yellow-600 fill-opacity-20" />
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/077526e80df6595ab71c00788b3a9e12ea1dfdd7ed1017c00c1c9e91f217aab0?apiKey=aa921c22d5e8470a9701bc1a79b29d5d&" alt="" className="absolute top-6 right-1/4 w-9 aspect-[0.67] fill-yellow-600 fill-opacity-20" />
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/82d0cc958661239053bacf859eb20cb7705bd8eaaa3a7ec83096b7f29ce6c224?apiKey=aa921c22d5e8470a9701bc1a79b29d5d&" alt="" className="absolute bottom-24 right-14 aspect-[0.66] fill-teal-300 fill-opacity-20 w-[49px] max-md:mt-10" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:py-12">
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-center space-x-3">
            <span className="block w-10 h-1 bg-cyan-600"></span>
            <h3 className="text-gray-900 font-bold">NOS DERNIERS ÉVÈNEMENTS</h3>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => handleManualScroll(-320)}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-900 text-white hover:bg-cyan-600 transition-colors duration-200"
              aria-label="Précédent"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button
              onClick={() => handleManualScroll(320)}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-900 text-white hover:bg-cyan-600 transition-colors duration-200"
              aria-label="Suivant"
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>

        <div
          className="infinite-scroll-wrapper"
          ref={scrollRef}
          onMouseEnter={() => (isPaused.current = true)}
          onMouseLeave={() => (isPaused.current = false)}
        >
          <ul className="infinite-scroll mt-6">
            {[...pastEvents, ...pastEvents].map((event, idx) => (
              <li className="infinite-scroll-item w-[384px]" key={`${event.id}-${idx}`}>
                <a href={event.href}>
                  <div className="relative w-full pt-[140%]">
                    <img
                      src={event.img}
                      alt={event.title}
                      className="absolute inset-0 shadow-md w-full h-full object-fill rounded-lg"
                    />
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default DernierEvent;
